<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <crud-list
          :fetch-data="fetchCustomLists"
          :create-allowed="isPowerUserOrAdministrator"
          title="Listes"
          @create="create"
          @row-clicked="rowClicked"
        >
          <el-table-column label="Nom" min-width="40" property="name" />
          <el-table-column
            label="Institutions"
            min-width="20"
            property="numberOfLinkedInstitutions"
          />
          <el-table-column
            label="Commissions"
            min-width="20"
            property="numberOfLinkedCommittees"
          />
          <el-table-column
            label="Personnes"
            min-width="20"
            property="numberOfLinkedPeople"
          />
          <el-table-column
            label="Thèmes"
            min-width="20"
            property="numberOfLinkedProfiles"
          />
          <el-table-column
            label="Utilisateur"
            min-width="20"
            property="userId"
          />
          <el-table-column label="Modification" min-width="20"
            ><div slot-scope="slotScope">
              {{ slotScope.row.lastUpdateDate | moment('DD.MM.YYYY') }}&nbsp;
            </div></el-table-column
          >
        </crud-list>
      </div>
    </div>
  </div>
</template>

<script>
import { isPowerUserOrAdministrator } from '@/services/AuthService';
import CrudList from './CrudList.vue';

export default {
  components: {
    CrudList,
  },
  data() {
    return {
      searchText: '',
    };
  },
  computed: {
    isPowerUserOrAdministrator,
  },
  created() {
    if (this.$route.params && this.$route.params.searchText) {
      this.searchText = this.$route.params.searchText;
    }
  },
  methods: {
    rowClicked(row) {
      this.$router.push({
        name: 'CustomListDetails',
        params: { id: row.id, newListCreation: false },
      });
    },
    fetchCustomLists(pageNumber, pageSize, searchText) {
      let url = process.env.VUE_APP_ANNUAIRE_API_URL;
      // If a searchText is defined within the component (coming from the route parameter in created method), fetch customLists corresponding to that text
      if (this.searchText) {
        // eslint-disable-next-line no-param-reassign
        searchText = this.searchText;
        // Reset component's searchText
        this.searchText = '';
      }
      if (searchText) {
        url += `/customlistEntities/search/fulltext?projection=noDetailsDTO&sort=clistName&name=${searchText}&userId=${searchText}&page=${pageNumber -
          1}&size=${pageSize}`;
      } else {
        url += `/customlistEntities?projection=noDetailsDTO&sort=clistName&page=${pageNumber -
          1}&size=${pageSize}`;
      }
      return this.$http.get(url).then(response => ({
        records: response.data._embedded.customlistEntities
          ? response.data._embedded.customlistEntities
          : [],
        page: response.data.page,
      }));
    },
    create() {
      this.$router.push({
        name: 'CustomListDetails',
        params: { id: 0, newListCreation: true },
      });
    },
  },
};
</script>

<style scoped></style>
